import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
import { Box, List } from '@mui/material';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import dateFormat from 'dateformat';
import { usePreRegBookingInfoQuery } from '../generated/graphql';
import { ExpandMore } from '../Components/ExpandMore';
import { MainWrapper } from '../Components/MainWrapper';

export default function BookingInfo() {
  const { state }: any = useLocation();

  const { data: { PreRegBookingInfo } = { PreRegBookingInfo: [] } } = usePreRegBookingInfoQuery({
    variables: {
      HotelID: state?.HotelID,
      BookingID: state?.BookingID,
    },
    fetchPolicy: 'no-cache',
  });

  const [expanded, setExpanded] = useState<any[]>([]);
  const [guest, setGuest] = useState<any[]>([]);

  useEffect(() => {
    const arr = PreRegBookingInfo?.result?.map((t: any) => ({
      ID: t.RoomType,
      SharerNo: t.SharerNo,
      IsExpanded: false,
    })) ?? [];
    setExpanded(arr);
  }, [PreRegBookingInfo]);

  useEffect(() => {
    const guestArr = PreRegBookingInfo?.result
      ?.slice()
      ?.sort((a: any, b: any) => a.Registrations[0]?.SharerNo - b.Registrations[0]?.SharerNo)
      ?.map((t: any, i: number) => ({
        ContactInfo: t.Registrations.map((y: any, i2: number) => ({
          ...y,
          Order: i2 + 1,
        })),
        RoomType: t.RoomType,
        SharerNo: t.SharerNo,
      })) ?? [];
    setGuest(guestArr);
  }, [PreRegBookingInfo]);

  const handleExpandClick = (shareNo: any) => {
    const newArray = expanded.map((f: any) => {
      if (f.SharerNo === shareNo) {
        return { ...f, IsExpanded: !f.IsExpanded };
      }
      return { ...f };
    });
    setExpanded(newArray);
  };

  const Guest = state?.Guest === 1 ? 'Guest' : 'Guests';

  return (
    <MainWrapper>
      <Box
        sx={{ p: 2 }}
        justifyContent="center"
        alignItems="center"
        width="400px"
        margin="auto"
        bgcolor="#F7FAF7"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" mb="12px" alignItems="center" justifyContent="center">
              <img
                src={state?.HotelDetails?.LogoImage?.ImageURL as any}
                alt="Hotel Logo"
                loading="lazy"
                width="180px"
              />
            </Box>
            <Typography fontSize="17px" fontWeight={600} mb="8px" align="center">
              Pre Registration Successful
            </Typography>
            <Typography fontSize="13px" fontWeight={500} mb="12px" color="black" align="center">
              Thank you
            </Typography>
          </Grid>
        </Grid>
        <Box display="flex" height={20} mb="12px">
          <Typography fontSize="14px" fontWeight={600}>
            Booking Info
          </Typography>
        </Box>
        <Card
          sx={{
            mb: '14px',
            borderRadius: '4px',
            boxShadow:
              '0 3px 1px -2px transparent, 2px 5px 4px -2px rgb(0 0 0 / 15%), -2px -1px 4px -2px rgb(0 0 0 / 15%)',
          }}
        >
          <CardContent sx={{ ':last-child': { p: '10px' } }}>
            <Box width="100%" display="flex" mb="10px">
              <Box width="50%" display="flex">
                <Typography fontSize="14px" fontWeight={500} color="black" align="left">
                  Booking No.
                </Typography>
              </Box>
              <Box width="50%" display="flex" sx={{ flexDirection: 'row-reverse' }}>
                <Typography fontSize="14px" fontWeight={500} color="secondary">
                  {PreRegBookingInfo?.BookingNo}
                </Typography>
              </Box>
            </Box>
            <Box width="100%" display="flex">
              <Box width="50%" display="flex" alignItems="center">
                <Typography fontSize="14px" fontWeight={500} color="black">
                  No of Room(s)
                </Typography>
              </Box>
              <Box width="50%" display="flex" sx={{ flexDirection: 'row-reverse' }}>
                <Typography fontSize="14px" fontWeight={500} color="secondary">
                  {PreRegBookingInfo?.result?.length}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
        <div className="rm-padding p-10">
          <List className="core-list reset-listitem">
            {guest?.map((x: any, i: number) => (
              <Card
                key={x.SharerNo}
                sx={{
                  mb: '14px',
                  borderRadius: '4px',
                  boxShadow:
                    '0 3px 1px -2px transparent, 2px 5px 4px -2px rgb(0 0 0 / 15%), -2px -1px 4px -2px rgb(0 0 0 / 15%)',
                }}
              >
                <CardActions disableSpacing>
                  <Box width="100%" display="flex" sx={{ flexDirection: 'column', margin: '5px' }}>
                    <Typography fontSize="17px" fontWeight={600} mb="8px">
                      Registration Info
                    </Typography>
                  </Box>
                  <Box width="100%" display="flex" sx={{ justifyContent: 'flex-end' }}>
                    <ExpandMore
                      expand={expanded?.find((y: any) => y.SharerNo === x.SharerNo)?.IsExpanded ?? false}
                      onClick={() => handleExpandClick(x.SharerNo)}
                    >
                      <ExpandMoreIcon />
                    </ExpandMore>
                  </Box>
                </CardActions>
                <Collapse
                  in={expanded?.find((y: any) => y.SharerNo === x.SharerNo)?.IsExpanded ?? false}
                  timeout="auto"
                  unmountOnExit
                >
                  <CardContent>
                    <Typography fontSize="14px" fontWeight={600} color="black" align="left">
                      {'Room ' + (i + 1) + ' - ' + x.ContactInfo[0]?.RoomType?.Description}
                    </Typography>
                    <Typography fontSize="14px" fontWeight={600} color="black" align="left">
                      {dateFormat(x.ContactInfo[0]?.ArrivalDate, 'dd mmm yyyy')} -{' '}
                      {dateFormat(x.ContactInfo[0]?.DepartureDate, 'dd mmm yyyy')}
                    </Typography>
                    <Typography
                      style={{ display: 'flex', alignItems: 'center' }}
                      fontSize="14px"
                      fontWeight={600}
                      color="black"
                      align="left"
                    >
                      <PersonIcon sx={{ fontSize: 20, color: 'black', marginRight: '5px' }} />
                      {state?.Guest + ' ' + Guest}
                    </Typography>
                    {x?.ContactInfo?.map((k: any, index2: number) => (
                      <Box
                        key={index2}
                        sx={{ display: 'flex', flexDirection: 'column' }}
                      >
                        <Grid container spacing={0}>
                          <Grid item xs={1} sx={{ pt: '15px', fontSize: '14px' }}>
                            {index2 + 1 + '. '}
                          </Grid>
                          <Grid item xs={11}>
                            <Box sx={{ display: 'flex', pt: '15px' }}>
                              <Typography fontSize="13px" fontWeight={600} color="black" align="left">
                                Guest Name
                              </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', mb: '5px', pt: '4px' }}>
                              <Typography fontSize="15px" fontWeight={500} color="black" align="left">
                                {k?.Guest?.Contact?.FullName || ''}
                              </Typography>
                            </Box>
                            <Box sx={{ display: 'flex' }}>
                              <Typography fontSize="13px" fontWeight={600} color="black" align="left">
                                Email
                              </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', mb: '10px', pt: '4px' }}>
                              <Typography fontSize="15px" fontWeight={500} color="black" align="left">
                                {k?.Guest?.Contact?.Email || ''}
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    ))}
                  </CardContent>
                </Collapse>
              </Card>
            ))}
          </List>
        </div>
        <Typography fontSize="14px" fontWeight={500} mb="10px" justifyContent="center" display="flex">
          * An email will be forwarded to you soon for the precheckin process.
        </Typography>
      </Box>
    </MainWrapper>
  );
}
